/**************************************************************************************************/
/*   File: /src/app/stores/actions/download/download.actions.ts                                   */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';

/**
 * The actions type used inside the download state
 */
export enum DownloadActionsType {
  /**
   * The select plan type action's identifier
   */
  SELECT_PLAN_TYPE = '[Download] Select plan type',
  /**
   * The add ambito action's identifier
   */
  ADD_AMBITO = '[Download] Add an ambito',
  /**
   * The remove ambito action's identifier
   */
  REMOVE_AMBITO = '[Download] Remove an ambito',
  /**
   * The select geo file type action's identifier
   */
  SELECT_GEO_FILE_TYPE = '[Download] Select geo file type',
  /**
   * The rehydrate dossier content action's identifier
   */
  REHYDRATE_DOSSIER_CONTENT = '[Download] Rehydrate dossier content',
  /**
   * The select geometries action's identifier
   */
  SELECT_GEOMETRIES = '[Download] Select geometries',
  /**
   * The reset geometries action's identifier
   */
  RESET_GEOMETRIES = '[Download] Reset geometries',
  /**
   * The prepare download action's identifier
   */
  PREPARE_GEOMETRIC_DOWNLOAD = '[Download] Prepare geometric data for download',
  /**
   * The prepare download success action's identifier
   */
  PREPARE_GEOMETRIC_DOWNLOAD_SUCCESS = '[Download] Prepare geometric download success',
  /**
   * The prepare download fail action's identifier
   */
  PREPARE_GEOMETRIC_DOWNLOAD_FAIL = '[Download] PRepare download fail',
  /**
   * The prepare regulations download
   */
  PREPARE_REGULATIONS_DOWNLOAD = '[Download] Prepare regulations array download',
  /**
   * The prepare regulations download fail
   */
  PREPARE_REGULATIONS_DOWNLOAD_FAIL = '[Download] Prepare regulations array download fail',
  /**
   * The prepare regulations download 
   */
  PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD = '[Download] Prepare regulations for ambito download',
  /**
   * The prepare regulations for ambito download success
   */
  PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_SUCCESS = '[Download] Prepare regulations for ambito download success',
  /**
   * The prepare regulations for ambito download fail
   */
  PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_FAIL = '[Download] Prepare regulations for ambito download fail',
  /**
   * The reset download state action's identifier
   */
  RESET_DOWNLOAD_STATE = '[Download] Reset download state',
  /**
   * Load ambiti by plan
   */
  LOAD_AMBITI_BY_PLAN = '[Download] Load ambiti by plan',
  /**
   * Load ambiti by plan success
   */
  LOAD_AMBITI_BY_PLAN_SUCCESS = '[Download] Load ambiti by plan success',
  /**
   * Load ambiti by plan fail
   */
  LOAD_AMBITI_BY_PLAN_FAIL = '[Download] Load ambiti by plan fail',
  /**
   * Check download status
   */
  CHECK_DOWNLOAD_STATUS = '[Download] Check status download',
  /**
   * Check download status success
   */
  CHECK_DOWNLOAD_STATUS_SUCCESS = '[Download] Check status download success',
  /**
   * Check download status fail
   */
  CHECK_DOWNLOAD_STATUS_FAIL = '[Download] Check status download fail',
  /**
   * Load public document
   */
  LOAD_PUBLIC_DOCUMENT = '[Download] Load public document',
  /**
   * Load public document success
   */
  LOAD_PUBLIC_DOCUMENT_SUCCESS = '[Download] Load public document success',
  /**
   * Load public document fail
   */
  LOAD_PUBLIC_DOCUMENT_FAIL = '[Download] Load public document fail'

}

/**
 * This action tells to the system that a plan type is selected
 */
export class SelectPlanType implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.SELECT_PLAN_TYPE;

  /**
   * Construct the select plan type
   * @param payload The planType code
   */
  constructor(public payload: { planCode: string }) { }
}
/**
 * This action tells to the system that an ambito is added to selected
 */
export class AddAmbito implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.ADD_AMBITO;

  /**
   * Construct the add ambito
   * @param payload The ambito code
   */
  constructor(public payload: { ambitoCode: string }) { }
}
/**
 * This action tells to the system that an ambito is removed from selected
 */
export class RemoveAmbito implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.REMOVE_AMBITO;

  /**
   * Construct the remove ambito
   * @param payload The ambito code
   */
  constructor(public payload: { ambitoCode: string }) { }
}
/**
 * This action tells to the system that a output file type is selected
 */
export class SelectGeoFileType implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.SELECT_GEO_FILE_TYPE;

  /**
   * Construct the select fileType
   * @param payload The spatial data type
   */
  constructor(public payload: { defaultSpatialDataType: fromShared.enums.SpatialDataTypeEnum }) { }
}
/**
 * This action reload the dossier content from local storage to state
 */
export class RehydrateDossierContent implements Action {
  /**
   * The type 
   */
  readonly type = DownloadActionsType.REHYDRATE_DOSSIER_CONTENT;
  /**
   * The constructor
   * @param payload The payload containing the dossier content
   */
  constructor(public payload: { dossierContent: fromShared.models.DossierContent }) { }
}
/**
 * This action will set geometries to store in the state
 */
export class SelectGeometries implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.SELECT_GEOMETRIES;

  /**
   * The constructor of download action type select geometries
   * @param payload The payload is user data
   */
  constructor(public payload: any) {
    console.log(payload);
  }
}
/**
 * This action will reset geometries in the state
 */
export class ResettedGeometries implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.RESET_GEOMETRIES;
}
/**
 * This action will prepare download
 */
export class PrepareGeometricDownload implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD;
  /**
   * The constructor
   * @param payload The payload containing data
   */
  constructor(public payload: { data: fromShared.models.GeometricExportInput }) { }
}
/**
 * This action notify the success
 */
export class PrepareGeometricDownloadSuccess implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD_SUCCESS;

  /**
   * Construct Prepare downlaod succss
   * @param payload The object containing taskid
   */
  constructor(public payload: { taskId: number }) { }
}
/**
 * This action notify the prepareation fail
 */
export class PrepareGeometricDownloadFail implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD_FAIL;

  /**
   * Construct Prepare downlaod fail
   * @param payload The object containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * This action will prepare download
 */
export class PrepareRegulationsDownload implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_REGULATIONS_DOWNLOAD;
  /**
   * Construct prepare regulation download
   * @param payload The payload containing data
   */
  constructor(public payload: { plan: string, ambiti: fromShared.models.Ambito[] }) { }
}
/**
 * This action notify the prepareation fail
 */
export class PrepareRegulationsDownloadFail implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_REGULATIONS_DOWNLOAD_FAIL;

  /**
   * Construct prepare regulations download fail
   * @param payload The object containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * This action notify the success for download regulation for ambito
 */
export class PrepareRegulationForAmbitoDownload implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD;

  /**
   * Construct prepare regulation for ambito download
   * @param payload The object containing ambito type, ambito code, plancode
   */
  constructor(public payload: { ambitoType: number, ambitoCode: string, planCode: string }) { }
}
/**
 * This action notify the success for download regulation for ambito success
 */
export class PrepareRegulationForAmbitoDownloadSuccess implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_SUCCESS;

  /**
   * Construct prepare regulation for ambito download success
   * @param payload The object containing exists 
   */
  constructor(public payload: { regulationResponse: fromShared.models.RegulationResponse }) { }
}
/**
 * This action notify the success for download regulation for ambito fail
 */
export class PrepareRegulationForAmbitoDownloadFail implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_FAIL;

  /**
   * Construct prepare regulation for ambito download fail
   * @param payload The object the message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * This action rest download state
 */
export class ResetDownload implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.RESET_DOWNLOAD_STATE;
}
/**
 * Load ambiti by plan
 */
export class LoadAmbitiByPlan implements Action {
  /**
  * The type
  */
  readonly type = DownloadActionsType.LOAD_AMBITI_BY_PLAN;

  /**
   * The constructor
   * @param payload Payload containing plancode
   */
  constructor(public payload: { planCode: string }) { }
}
/**
* Load ambiti by plan success
*/
export class LoadAmbitiByPlanSuccess implements Action {
  /**
  * The type
  */
  readonly type = DownloadActionsType.LOAD_AMBITI_BY_PLAN_SUCCESS;

  /**
   * The constructor
   * @param payload the ambiti array
   */
  constructor(public payload: { ambiti: fromShared.models.Ambito[] }) { }
}

/**
* Load ambiti by plan fail
*/
export class LoadAmbitiByPlanFail implements Action {
  /**
  * The type
  */
  readonly type = DownloadActionsType.LOAD_AMBITI_BY_PLAN_FAIL;

  /**
   * The constructor
   * @param payload containing the message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The check download status action
 */
export class CheckDownloadStatus implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.CHECK_DOWNLOAD_STATUS;
  /**
   * The constructor
   * @param payload The payload
   */
  constructor(public payload: { taskId: number }) { }
}
/**
 * The check download status action success
 */
export class CheckDownloadStatusSuccess implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.CHECK_DOWNLOAD_STATUS_SUCCESS;
  /**
   * The constructor
   * @param payload The payload result 
   */
  constructor(public payload: { completed: boolean }) { }
}
/**
 * The check download status action fail
 */
export class CheckDownloadStatusFail implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.CHECK_DOWNLOAD_STATUS_FAIL;
  /**
   * The constructor
   * @param payload the payload containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The load public document
 */
export class LoadPublicDocument implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.LOAD_PUBLIC_DOCUMENT;
  /**
   * The constructor
   * @param payload The payload
   */
  constructor(public payload: { plan: string, type: fromShared.enums.SpatialDataTypeEnum}) { }
}
/**
 * The load public document success
 */
export class LoadPublicDocumentSuccess implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.LOAD_PUBLIC_DOCUMENT_SUCCESS;
  /**
   * The constructor
   * @param payload The payload result 
   */
  constructor(public payload: { documents: any[] }) { }
}
/**
 * The load public document fail
 */
export class LoadPublicDocumentFail implements Action {
  /**
   * The type
   */
  readonly type = DownloadActionsType.LOAD_PUBLIC_DOCUMENT_FAIL;
  /**
   * The constructor
   * @param payload the payload containing message
   */
  constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
 * The auth actions type
 */
export type DownloadActions =
  SelectPlanType |
  AddAmbito |
  RemoveAmbito |
  SelectGeoFileType |
  RehydrateDossierContent |
  SelectGeometries |
  ResettedGeometries |
  PrepareGeometricDownload |
  PrepareGeometricDownloadSuccess |
  PrepareGeometricDownloadFail |
  PrepareRegulationsDownload |
  PrepareRegulationsDownloadFail |
  PrepareRegulationForAmbitoDownload |
  PrepareRegulationForAmbitoDownloadSuccess |
  PrepareRegulationForAmbitoDownloadFail |
  ResetDownload |
  LoadAmbitiByPlan |
  LoadAmbitiByPlanSuccess |
  LoadAmbitiByPlanFail |
  LoadPublicDocument |
  LoadPublicDocumentSuccess |
  LoadPublicDocumentFail;
